import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateCommunityProfilePayload } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { userQueryOptions } from '../user';
import { userCommunityProfileSchema } from './schemas';

export const useUpdateCommunityProfile = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateCommunityProfilePayload) => {
      const { data: communityProfile } = await fetchJson(`/community/${id}`, {
        method: 'PATCH',
        schema: apiResourceSchema(userCommunityProfileSchema),
        body,
      });

      return communityProfile;
    },
    onSuccess: (communityProfile) => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => (user ? { ...user, communityProfile } : undefined));
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
